import React from "react";
import Map3 from "../core/Map3";
import {
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@material-ui/core";
import { loadModules } from "esri-loader";
import { withStyles } from "@material-ui/core/styles";
import primaryColor from "../../theme/primaryColor";
import { connect } from "react-redux";

import clsx from "clsx";

import Drawer from "@material-ui/core/Drawer";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SateliteImages from "./SateliteImages";
import HotSpots from "./HotSpots";
import AirQuality from "./AirQuality";
import Earthquake from "./Earthquake";
import Popocatepetl from "./Popocatepetl";
import Marquee from "react-fast-marquee";
import Temperature from "./Temperature";
import Precipitation from "./Precipitation";
import {
  fetchUltimasAlertasAction,
  clearUltimasAlertasAction,
} from "../../actions/alerts/alertasActions";
import { fetchModuleLayersAction } from "../../actions/catalogs/catalogActions";
import { isMobile } from "react-device-detect";
import ArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
const appSub = process.env.REACT_APP_SUB;

//Objeto raiz para almacenar los objectos de esri
let esri = {
  Polygon: null,
  Graphic: null,
  FeatureLayer: null,
  Draw: null,
  projection: null,
  loaded: false,
  Circle: null,
  MapImageLayer: null,
  SpatialReference: null,
  Extent: null,
  MapImage: null,
  Point: null,
  InfoTemplate: null,
  PictureMarkerSymbol: null,
  UniqueValueRenderer: null,
  GraphicsLayer: null,
  SimpleMarkerSymbol: null,
  SimpleLineSymbol: null,
  Color: null,
  graphicsUtils: null,
  ClassBreaksRenderer: null,
  SimpleFillSymbol: null,
  SimpleRenderer: null,
  Legend: null,
  TextSymbol: null,
};

const layerCDMX = process.env.REACT_APP_CDMX_LAYER;

//Estilos del componente
const useStyles = (theme) => ({
  root: {
    display: "flex",
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    zIndex: 0,
  },
  drawerClosed: {
    width: 0,
    flexShrink: 0,
    zIndex: 0,
  },

  drawerPaper: {
    width: drawerWidth,
    //marginTop: isMobile ? 109 : 115,
  },
  drawerPaperClosed: {
    width: 0,
  },

  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start",
    backgroundColor: primaryColor.main,
  },
  content: {
    flexGrow: 1,

    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
  },

  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
});

//Ancho del panel derecho
const drawerWidth = isMobile ? 320 : 450;
const intervalAlerts = 1 * 60 * 1000;

//Componente genereal de Monitoreo
class Monitoring extends React.Component {
  //Definición del estado inicial del componente
  constructor(props) {
    super(props);

    this.state = {
      mapView: null,
      isDetailOpen: true,

      isMainLayerLoaded: false,

      locationWidget: null,

      marqueeVisible: false,
      marqueeVisibleNubes: false,
      marqueeText: "",
      alertText: "",
      addedLayers: [],
    };
    this.props.fetchUltimasAlertasAction();
    this.props.fetchModuleLayersAction();

    setInterval(() => {
      this.props.fetchUltimasAlertasAction();
    }, intervalAlerts);
    //Obtiene los modulos de esri
    loadModules(
      [
        "esri/layers/FeatureLayer",
        "esri/layers/MapImageLayer",
        "esri/SpatialReference",
        "esri/geometry/Extent",
        "esri/layers/MapImage",
        "esri/graphic",
        "esri/geometry/Point",
        "esri/InfoTemplate",
        "esri/symbols/PictureMarkerSymbol",
        "esri/renderers/UniqueValueRenderer",
        "esri/layers/GraphicsLayer",
        "esri/symbols/SimpleMarkerSymbol",
        "esri/symbols/SimpleLineSymbol",
        "esri/Color",
        "esri/graphicsUtils",
        "esri/renderers/ClassBreaksRenderer",
        "esri/symbols/SimpleFillSymbol",
        "esri/renderers/SimpleRenderer",
        "esri/dijit/Legend",
        "esri/symbols/TextSymbol",
      ],
      {
        dojoConfig: {
          locale: "es",
        },
        version: "3.36",

        css: true,
      }
    ).then(
      ([
        FeatureLayer,
        MapImageLayer,
        SpatialReference,
        Extent,
        MapImage,
        Graphic,
        Point,
        InfoTemplate,
        PictureMarkerSymbol,
        UniqueValueRenderer,
        GraphicsLayer,
        SimpleMarkerSymbol,
        SimpleLineSymbol,
        Color,
        graphicsUtils,
        ClassBreaksRenderer,
        SimpleFillSymbol,
        SimpleRenderer,
        Legend,
        TextSymbol,
      ]) => {
        esri.FeatureLayer = FeatureLayer;
        esri.MapImageLayer = MapImageLayer;
        esri.SpatialReference = SpatialReference;
        esri.Extent = Extent;
        esri.MapImage = MapImage;
        esri.loaded = true;
        esri.Graphic = Graphic;
        esri.Point = Point;
        esri.InfoTemplate = InfoTemplate;
        esri.PictureMarkerSymbol = PictureMarkerSymbol;
        esri.UniqueValueRenderer = UniqueValueRenderer;
        esri.GraphicsLayer = GraphicsLayer;
        esri.SimpleMarkerSymbol = SimpleMarkerSymbol;
        esri.SimpleLineSymbol = SimpleLineSymbol;
        esri.Color = Color;
        esri.graphicsUtils = graphicsUtils;
        esri.ClassBreaksRenderer = ClassBreaksRenderer;
        esri.SimpleFillSymbol = SimpleFillSymbol;
        esri.SimpleRenderer = SimpleRenderer;
        esri.Legend = Legend;
        esri.TextSymbol = TextSymbol;
        this.forceUpdate();
      }
    );
  }

  //Crarga la capa inicial del mapa para dibujar la CDMX
  onLoadedMap = (mapView) => {
    this.setState(
      {
        mapView: mapView,
      },
      () => {
        var CDMX = "";
        var countiesUrl = layerCDMX;
        var hColor = "#235B4E";
        var outline = new esri.SimpleLineSymbol().setColor(hColor).setWidth(3);
        var renderer = new esri.SimpleRenderer(outline);

        let neCounties = esri.FeatureLayer(countiesUrl, {
          id: "CDMX",
        });

        neCounties.setDefinitionExpression(CDMX);
        neCounties.setRenderer(renderer);
        this.state.mapView.addLayer(neCounties);
      }
    );
  };

  //Obtiene el nombre del municipio dada una clave
  obtenerNomberMun(municipio) {
    let nombre = "";
    switch (municipio) {
      case "AlvaroObregon":
        nombre = "Álvaro Obregón";
        break;
      case "Azcapotzalco":
        nombre = "Azcapotzalco";
        break;
      case "BenitoJuarez":
        nombre = "Benito Juárez";
        break;
      case "Coyoacan":
        nombre = "Coyoacán";
        break;
      case "Cuajimalpa":
        nombre = "Cuajimalpa de Morelos";
        break;
      case "Cuahutemoc":
        nombre = "Cuauhtémoc";
        break;
      case "Gustavo":
        nombre = "Gustavo A. Madero";
        break;
      case "Iztacalco":
        nombre = "Iztacalco";
        break;
      case "Iztapalapa":
        nombre = "Iztapalapa";
        break;
      case "Magdalena":
        nombre = "La Magdalena contreras";
        break;
      case "Hidalgo":
        nombre = "Miguel Hidalgo";
        break;
      case "MilpaAlta":
        nombre = "Milpa Alta";
        break;
      case "Tlahuac":
        nombre = "Tláhuac";
        break;
      case "Tlalpan":
        nombre = "Tlalpan";
        break;
      case "VenustianoCarranza":
        nombre = "Venustiano Carranza";
        break;
      case "Xochimilco":
        nombre = "Xochimilco";
        break;
      default:
        break;
    }
    return nombre;
  }

  //Obtiene el nivel de severidad dada una clave
  obtenerNonmbreSeveridad(sev) {
    let nombre = "";
    switch (sev) {
      case "Minor":
        nombre = "Menor";
        break;
      case "Moderate":
        nombre = "Moderada";
        break;
      case "Severe":
        nombre = "Severa";
        break;
      case "Extreme":
        nombre = "Extrema";
        break;
      case "Unknown":
        nombre = "";
        break;
      default:
        break;
    }
    return nombre;
  }

  //Obtiene el fenómeno dada una clave
  obtenerNombreFenomeno(fen) {
    let complemento;
    switch (fen) {
      case "lluvia":
        complemento = "Lluvias";
        break;
      case "granizo":
        complemento = "Granizo";
        break;
      case "viento":
        complemento = "Viento";
        break;
      case "bajasTemp":
        complemento = "Temperatura baja";
        break;
      case "altasTemp":
        complemento = "Temperatura alta";
        break;
      case "nieve":
        complemento = "Caída de nieve";
        break;
      case "aguaNieve":
        complemento = "Agua nieve";
        break;
      default:
        break;
    }

    return complemento;
  }

  //Obtiene el nombre de color dada una clave de severidad
  getColors(severity) {
    let colorRGB;
    let color;
    switch (severity) {
      case "Minor":
        color = "verde";
        colorRGB = "green";
        break;
      case "Moderate":
        color = "amarilla";
        colorRGB = "yellow";
        break;
      case "Severe":
        color = "naranja";
        colorRGB = "orange";
        break;
      case "Extreme":
        color = "roja";
        colorRGB = "red";
        break;
      case "Unknown":
        color = "morada";
        colorRGB = "purple";
        break;
      default:
        break;
    }

    return { color, colorRGB };
  }

  //Obtiene el texto para el cintillo
  getMarqueeText() {
    let texto = "";

    return this.state.listaAlertas.map((t) => {
      texto = "";
      let mun = t.area?.areaDesc;
      if (mun) {
        mun = mun.substring(0, mun.indexOf(","));
        mun = this.obtenerNomberMun(mun);
      } else {
        mun = "N/A";
      }
      let color = this.getColors(t.severity);
      let fenomeno = this.obtenerNombreFenomeno(t.event);
      let intensidad = this.obtenerNonmbreSeveridad(t.severity);
      let txt =
        "   " +
        `Alerta ${color.color}. Fenómeno: ${fenomeno}. Intensidad: ${intensidad}, Alcaldía: ${mun}`;

      txt += t.description
        .substring(t.description.indexOf("Peligro:"), t.description.length)
        .replaceAll("Peligro:", ". Peligros: ")
        .replaceAll(".", ". ");

      txt += t.instruction
        ? "Recomendaciones: " + t.instruction.replaceAll(".", ". ")
        : t.instruction.replaceAll(".", ". ");
      texto += txt;
      return (
        <Box
          style={{
            backgroundColor: color.colorRGB,

            display: "inline",
            height: "50px",
          }}
        >
          <Typography
            variant="caption"
            style={{
              fontSize: "15pt",
              marginTop: 5,
              paddingLeft: 30,
              paddingRight: 30,

              color: t.severity === "Moderate" ? "black" : "white",
            }}
            component={Box}
          >
            {texto}
          </Typography>
        </Box>
      );
    });
  }

  //Lee las alertas trempranas y configura el estado inicial del mapa
  componentDidUpdate() {
    const { loadedAlertas, listaAlertas } = this.props;
//se desactivan las notificaciones de alerta temparana
    // if (loadedAlertas) {
    //   this.props.clearUltimasAlertasAction();
    //   let texto = "";

    //   listaAlertas.map((t) => {
    //     texto = t.severity;
    //     return texto;
    //   });
    //   this.setState({ alertText: texto, listaAlertas: listaAlertas });
    // }

    if (this.state.mapView) {
      var graphicsLayers = [
        { name: "airQualityCDMXIMECA", title: "" },
        { name: "airQualityCDMXConcentration", title: "" },
        { name: "ssn", title: "" },
        { name: "ssni", title: "" },
        { name: "wazeAlerts", title: "" },
        { name: "wazeJams", title: "" },
      ];
      var mapPointsLayers = [
        { name: "automaticStationsRain", title: "" },
        { name: "automaticStationsTemperature", title: "" },
        { name: "hotPointsDiurno", title: "" },
        { name: "hotPointsNocturno", title: "" },
      ];
      var mapImageLayers = [
        { name: "rgbClouds", title: "" },
        { name: "topClouds", title: "" },
        { name: "radarImages", title: "" },
      ];

      mapImageLayers.forEach((layer) => {
        var gl = new esri.MapImageLayer({
          id: layer.name,
          opacity: 0.8,
          visible: false,
        });
        this.state.mapView.addLayer(gl);
      });

      var featureCollectionRain = {
        layerDefinition: null,
        featureSet: {
          features: [],
          geometryType: "esriGeometryPoint",
        },
      };

      featureCollectionRain.layerDefinition = {
        geometryType: "esriGeometryPoint",
        objectIdField: "ObjectID",
        drawingInfo: {
          renderer: {
            type: "simple",
            symbol: {
              type: "esriPMS",
              url: "./imagenes/Temperatura/SinServicio.png",
              contentType: "image/png",
              width: 15,
              height: 12,
            },
          },
        },
        fields: [
          {
            name: "ObjectID",
            alias: "ObjectID",
            type: "esriFieldTypeOID",
          },
          {
            name: "nombreEstacion",
            alias: "Nombre de estación",
            type: "esriFieldTypeString",
          },
          {
            name: "organismo",
            alias: "Organismo",
            type: "esriFieldTypeString",
          },
          {
            name: "estado",
            alias: "Estado",
            type: "esriFieldTypeString",
          },
          {
            name: "municipio",
            alias: "Municipio",
            type: "esriFieldTypeString",
          },
          {
            name: "fechaLocal",
            alias: "Fecha Local del Centro",
            type: "esriFieldTypeString",
          },
          {
            name: "fechaUTC",
            alias: "Fecha UTC",
            type: "esriFieldTypeString",
          },
          {
            name: "precipitacion",
            alias: "Precipitación acumulada (mm)",
            type: "esriFieldTypeDouble",
          },
        ],
      };

      var featureCollectionHotPoints = {
        layerDefinition: {
          geometryType: "esriGeometryPoint",
          objectIdField: "ObjectID",
          drawingInfo: {
            renderer: {
              type: "simple",
              symbol: {
                type: "esriPMS",
                url: `.${appSub}/imgs/CONABIO/noValue.png`,
                contentType: "image/png",
                width: 15,
                height: 12,
              },
            },
          },
          fields: [
            {
              name: "ObjectID",
              alias: "ObjectID",
              type: "esriFieldTypeOID",
            },
            {
              name: "fecha",
              alias: "Fecha y hora locales",
              type: "esriFieldTypeString",
            },
            {
              name: "estado",
              alias: "Estado",
              type: "esriFieldTypeString",
            },
            {
              name: "municipio",
              alias: "Municipio",
              type: "esriFieldTypeString",
            },
            {
              name: "vegatacion",
              alias: "Vegetación",
              type: "esriFieldTypeString",
            },
            {
              name: "anp",
              alias: "Área natural afectada",
              type: "esriFieldTypeString",
            },
            {
              name: "pendiente",
              alias: "Pendiente(%)",
              type: "esriFieldTypeDouble",
            },
            {
              name: "tipo",
              alias: "Tipo",
              type: "esriFieldTypeString",
            },
          ],
        },
        featureSet: {
          features: [],
          geometryType: "esriGeometryPoint",
        },
      };

      mapPointsLayers.forEach((layer) => {
        var pointsLayer = new esri.FeatureLayer(featureCollectionHotPoints, {
          id: layer.name,
          visible: true,
        });

        this.state.mapView.addLayer(pointsLayer);
      });

      graphicsLayers.forEach((layer) => {
        var gl = new esri.GraphicsLayer({
          id: layer.name,
          visible: false,
        });

        this.state.mapView.addLayer(gl);

        if (layer === "ssn") {
          var noOfRing = 0;
          var noOfLastRing = 0;

          gl.on("graphic-node-add", function (evt) {
            if (evt.graphic["attributes"]["type"] === "sismo") {
              evt.node.setAttribute("class", "sismo");
              if (noOfRing === 0) evt.node.setAttribute("class", "sismo");
              if (noOfRing === 1)
                evt.node.setAttribute("class", "sismo first-circle");
              else if (noOfRing === 2)
                evt.node.setAttribute("class", "sismo second-circle");
              else if (noOfRing === 3)
                evt.node.setAttribute("class", "sismo third-circle");

              if (noOfRing > 3) noOfRing = 0;
              else noOfRing++;
            } else if (evt.graphic["attributes"]["type"] === "ultimoSismo") {
              evt.node.setAttribute("class", "ultimoSismo");
              if (noOfLastRing === 0)
                evt.node.setAttribute("class", "ultimoSismo");
              if (noOfLastRing === 1)
                evt.node.setAttribute("class", "ultimoSismo first-circle");
              else if (noOfLastRing === 2)
                evt.node.setAttribute("class", "ultimoSismo second-circle");
              else if (noOfLastRing === 3)
                evt.node.setAttribute("class", "ultimoSismo third-circle");
              else if (noOfLastRing === 4)
                evt.node.setAttribute("class", "ultimoSismo crecimiento");

              if (noOfLastRing > 4) noOfLastRing = 0;
              else noOfLastRing++;
            }
          });
        }
      });
    }
  }

  //Renderea el mapa
  renderMap() {
    return (
      <Box
        color="white"
        position="absolute"
        style={{
          height: "calc(100vh)", // "calc(100vh - 116px)"
          width: "100%",
        }}
      >
        <Map3
          onLoadedMap={this.onLoadedMap}
          hasHome={true}
          hasBaseMaps={true}
          hasLegend={true}
          hasSearchBar={true}
          esri={esri}
          version="3.36"
          addedLayers={this.state.addedLayers}
        ></Map3>
      </Box>
    );
  }

  //Renderea el panel derecho
  renderDetail() {
    let variant = isMobile ? "caption" : "body2";
    let bold = isMobile ? "normal" : "bold";
    return (
      <Box p={1}>
        <Accordion style={{ marginBottom: 10, backgroundColor: "#F8F9F9" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant={variant} style={{ fontWeight: bold }}>
              Radar meteorológico e Imágenes Satelitales
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <SateliteImages
              esri={esri}
              mapView={this.state.mapView}
              moduleLayers={this.props.moduleLayers}
              setMarqueeNubesState={this.setMarqueeNubesState}
            ></SateliteImages>
          </AccordionDetails>
        </Accordion>

        <Accordion style={{ marginBottom: 10, backgroundColor: "#F8F9F9" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant={variant} style={{ fontWeight: bold }}>
              Volcán Popocatépetl
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Popocatepetl
              esri={esri}
              mapView={this.state.mapView}
              moduleLayers={this.props.moduleLayers}
            ></Popocatepetl>
          </AccordionDetails>
        </Accordion>

        <Accordion style={{ marginBottom: 10, backgroundColor: "#F8F9F9" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant={variant} style={{ fontWeight: bold }}>
              Calidad del aire CDMX
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <AirQuality
              esri={esri}
              mapView={this.state.mapView}
              setMarqueeState={this.setMarqueeState}
              moduleLayers={this.props.moduleLayers}
            ></AirQuality>{" "}
          </AccordionDetails>
        </Accordion>

        <Accordion style={{ marginBottom: 10, backgroundColor: "#F8F9F9" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant={variant} style={{ fontWeight: bold }}>
              Temperatura
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Temperature
              esri={esri}
              mapView={this.state.mapView}
              moduleLayers={this.props.moduleLayers}
            ></Temperature>
          </AccordionDetails>
        </Accordion>

        <Accordion style={{ marginBottom: 10, backgroundColor: "#F8F9F9" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant={variant} style={{ fontWeight: bold }}>
              Precipitación acumulada
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Precipitation
              esri={esri}
              mapView={this.state.mapView}
              moduleLayers={this.props.moduleLayers}
            ></Precipitation>
          </AccordionDetails>
        </Accordion>

        <Accordion style={{ marginBottom: 10, backgroundColor: "#F8F9F9" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant={variant} style={{ fontWeight: bold }}>
              Sismos
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Earthquake
              esri={esri}
              mapView={this.state.mapView}
              moduleLayers={this.props.moduleLayers}
            ></Earthquake>
          </AccordionDetails>
        </Accordion>

        <Accordion style={{ marginBottom: 10, backgroundColor: "#F8F9F9" }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant={variant} style={{ fontWeight: bold }}>
              Puntos de calor
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <HotSpots
              esri={esri}
              mapView={this.state.mapView}
              moduleLayers={this.props.moduleLayers}
            ></HotSpots>
          </AccordionDetails>
        </Accordion>
        <Box style={{ height: 120 }}></Box>
      </Box>
    );
  }

  //Renderea el componente inicial
  renderBrowser() {
    const { isDetailOpen } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <main
          className={clsx(classes.content, {
            [classes.contentShift]: isDetailOpen,
          })}
        >
          <div
            style={{
              height: "calc(100vh)", // "calc(100vh - 116px)",
              width: "100%",
              position: "relative",
              zIndex: 1000,
            }}
          >
            {this.renderMap()}
            {(this.state.marqueeVisible || this.state.alertText) && (
              <Marquee
                delay={1}
                speed={120}
                gradient={false}
                style={{
                  backgroundColor: "Orange",
                  color: "white",
                  position: "absolute",
                  bottom: "0",
                  zIndex: 100,
                  height: 50,
                }}
              >
                {this.getMarqueeText()}
                <Typography
                  variant="caption"
                  style={{
                    fontSize: "15pt",
                    marginTop: -5,
                    paddingLeft: 30,
                    paddingRight: 30,
                  }}
                  component={Box}
                >
                  {this.state.marqueeText}
                </Typography>
              </Marquee>
            )}
            {this.state.marqueeVisibleNubes && (
              <Marquee
                gradient={false}
                style={{
                  position: "absolute",
                  top: "1px",
                  zIndex: 100,
                }}
              >
                <img alt="cintillo" height="25" src="./imgs/simnubes.png"></img>
              </Marquee>
            )}
          </div>
        </main>
        <Box>
          <Button
            title="Ver fenómenos"
            style={{
              position: "relative",
              zIndex: 10100,
              left: -2,
              top: 20,
              backgroundColor: "white",
              width: 22,
              minWidth: 10,
              height: 33,
              borderWidth: 1,
              borderColor: "gray",
              borderStyle: "solid",
            }}
            onClick={() => {
              this.setState({ isDetailOpen: !isDetailOpen });
            }}
          >
            {!isDetailOpen ? (
              <ArrowLeftIcon></ArrowLeftIcon>
            ) : (
              <ArrowRightIcon></ArrowRightIcon>
            )}
          </Button>
          <Drawer
            className={isDetailOpen ? classes.drawer : classes.drawerClosed}
            variant="persistent"
            anchor="right"
            open={true}
            classes={{
              paper: isDetailOpen
                ? classes.drawerPaper
                : classes.drawerPaperClosed,
            }}
          >
            <Box mt={1}>
              <div>{this.props.loadedModuleLayers && this.renderDetail()}</div>
            </Box>
          </Drawer>
        </Box>
      </div>
    );
  }
//se oculta el cintillo de forma temporal
  //Establece el estado del cintillo
  setMarqueeState = (hidden, text) => {
    this.setState({ marqueeVisible: hidden, marqueeText: text });
  };

  //Establece el estado del cintillo para información de nubes
  setMarqueeNubesState = (visible) => {
    this.setState({ marqueeVisibleNubes: visible });
  };

  render() {
    return this.renderBrowser();
  }
}

//Obtiene los datos del estado general de la aplicación
const mapStateToProps = (state) => {
  return {
    listaAlertas: state.alertState.listaAlertas,
    totalAlertas: state.alertState.totalAlertas,
    loadedAlertas: state.alertState.loadedAlertas,
    moduleLayers: state.catalogState.moduleLayers,
    loadedModuleLayers: state.catalogState.loadedModuleLayers,
  };
};

export default connect(mapStateToProps, {
  fetchUltimasAlertasAction,
  clearUltimasAlertasAction,
  fetchModuleLayersAction,
})(withStyles(useStyles)(Monitoring));
